export const REGIONAL_TEXTS = {
  PAGE_TITLE: "Regionais",
  PAGE_SUBTITLE: "Gerencie os regionais do sistema",
  SEARCH_PLACEHOLDER: "Buscar regional...",
  STATUS_FILTER_PLACEHOLDER: "Filtrar por status",
  STATUS_ACTIVE: "Ativos",
  STATUS_INACTIVE: "Inativos",
  STATUS_ALL: "Todos",
  ERROR_INTERNAL_SERVER: "ERRO INTERNO NO SERVIDOR",
  MAX_STORES_TO_SHOW: 3,
};